import {getThemeImages, getAITCImages} from 'util/themeImages';

const initialState = {
    themeName: 'DEFAULT',
    storylineId: 1,
    images: getThemeImages('DEFAULT')
};

const images = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'SET_THEME':
            return {
                ...state,
                themeName: action.payload,
                images: getThemeImages(action.payload)
            };
        case 'SET_STORYLINE_DATA':
            const storylineId = action.payload.storylineDetails?.id || 1;
            return {
                ...state,
                storylineId: storylineId,
                images: getAITCImages(storylineId)
            };
        case 'SET_INIT_DATA':
            // Handle initial data loading which includes storyline data
            const initStorylineId = action.payload.storylineDetails?.id || 1;
            return {
                ...state,
                storylineId: initStorylineId,
                images: getAITCImages(initStorylineId)
            };
        default:
            return state;
    }
};

export default images;